import { convertStringInDate, sum } from "~services/GlobalServices";
import { applyRandomId, createVolumeInput } from "../utils";

const useFunnelActiveWorks = ({ }) => {

const convertProductFromWorksToTable = (products_grouped) => {
  const values = Object.values(products_grouped);
  const content = [];

  for (const value of values) {
    const accordion = {
      accordion_header: value[0].grupoNome,
      accordion_body: defineTableBody(value),
      error: false
    };
    content.push(accordion);
  }

  return content;
};



  const defineTableBody = (value) => {
      let body = null;
      let rows = [];

      const values = value;

      rows = values.map(e => {
        return {
          ...e,
          columns: applyRandomId([
            { value: e.codigoCliente},
            { value: e.volumeNegociado},
            { value: e.volumeContratado},
            { value: e.status},
          ]),
          dados: {
            ...e
          }
        }
      });

      let sub = {
        showSelectAll: false,
        header: {
          data:[
            { label: "Cód.Cliente" },
            { label: "Volume Negociado (t)" },
            { label: "Volume Faturado (t)" },
            { label: "Status" },
          ]
        },
        body: {
          actionButtons: ['edit'],
          rows,
        },
      };

      body = {
        actionButtons: [],
        header: {
          data: []
        },
        rows: [],
      };

      sub = {
        ...sub,
        is_accordion: false,
        show_more_header: true,
      };

      return {
        data: {
          body,
        },
        sub,
      };
    };

  return {
    convertProductFromWorksToTable,
  };
};

export default useFunnelActiveWorks;
